import { useCall } from '../customer-call-sdk';

export default function useCallInfoName() {
    const { calleeName, callerName, requestType, toPhoneNumber } = useCall();
    if (requestType === 'P2P') {
        return toPhoneNumber;
    }
    if (requestType === 'VRS_OUTBOUND') {
        return calleeName;
    }

    if (requestType === 'VRS_INBOUND') {
        return callerName;
    }

    return '';
}
